import styles from './Available.module.scss';
import { useLocalStorage } from '../../../../hooks';
import {
  Button,
  Content,
  FontAwesomeProIcon,
  Heading,
  Link,
} from '@wienenergiegithub/ui-next';
import React from 'react';
import PropTypes from 'prop-types';

const Available = ({ onClick, withNotify, configurationUrl }) => {
  const [storage] = useLocalStorage('address-check');

  // we show the address in the following format:
  // strasse gebadr1/tuerNr, plzOrt, e.g. "Musterstraße 1/2, 1234 Musterstadt" or
  // strasse gebadr1, plzOrt, e.g."Musterstraße 1, 1234 Musterstadt"
  const address = `${storage?.strasse} ${!storage?.gebadr1 || storage?.gebadr1.length === 0 ? storage?.olavKeys?.gebadr1 : storage.gebadr1}${
    storage?.tuerNr && storage?.gebadr1 ? '/' : ''
  }${storage?.tuerNr}, ${storage?.plzOrt}`;

  return (
    <div className={styles.container} data-purpose="superschnell-available">
      <div className={styles.checkmark}>
        <FontAwesomeProIcon icon="check" role="presentation" size="lg" />
      </div>
      <Heading noSpacing size="h5">
        SuperSchnell ist verfügbar!
      </Heading>
      <Content className={styles.address}>{address}</Content>
      {!!withNotify && (
        <Content>
          <strong>Sie werden zu den Tarifen weitergeleitet...</strong>
        </Content>
      )}
      {!!configurationUrl && (
        <Button
          className={styles.button}
          render={
            <Link isElevated to={configurationUrl?.url}>
              {configurationUrl?.title}
            </Link>
          }
        />
      )}
      {!withNotify && (
        <Button
          className={styles.button}
          isElevated
          onClick={onClick}
          variant={configurationUrl ? 'link' : ''}
        >
          Weitere Adresse Prüfen
        </Button>
      )}
    </div>
  );
};

Available.propTypes = {
  configurationUrl: PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
  }),
  onClick: PropTypes.func,
  withNotify: PropTypes.bool,
};

export { Available };
